import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import { InformationCircleIcon } from '@heroicons/react/solid'
import { StyledCurrentPlan, CurrentPlanCard } from '..'
import { SubInfoType } from '../../../types'
import { Button, Spinner } from '../../System'
import ROUTES from '../../utils/routes'
import { TRIAL, YEAR, FOREVER } from '../../utils/stripePrices'
import useSegment from '../../utils/useSegment'

type Props = {
  subscription?: SubInfoType | null;
  loadingSubscription: boolean;
  setShowModal: (showModal) => void;
  reactivateUserSub: () => void;
  processing: boolean;
}

const CurrentPlan: FC<Props> = ({
  subscription,
  loadingSubscription,
  setShowModal,
  reactivateUserSub,
  processing
}) => {
  const history = useHistory()

  const canRestartSubscription =
    subscription?.status === 'active' &&
    !subscription?.renews &&
    subscription?.plan?.interval !== TRIAL

  return (
    <StyledCurrentPlan>
      <div className="billing-header">
        <h3 className="billing-subheader">Current Plan</h3>
        {subscription?.plan?.interval !== YEAR && (
          <button
            onClick={() => history.push(ROUTES.user.settings.plan)}
            className="billing-button"
          >
            See All Plans
          </button>
        )}
      </div>
      {loadingSubscription && <Spinner />}
      {!subscription && !loadingSubscription && (
        <div className="current-plan-empty-state">
          <p>You don't have any active plans</p>
          <button onClick={() => history.push(ROUTES.user.settings.plan)} className="resubscribe">
            Select Plan
          </button>
        </div>
      )}
      {subscription && !loadingSubscription && (
        <>
          {subscription.interval === 'month' && subscription.plan?.interval !== TRIAL && (
            <CurrentPlanCard
              title="Monthly"
              interval="month"
              description="Simple marketing tools to get more followers, more engagement & more sales"
              price={subscription.price}
              showUpgrade
              renews={subscription.renews}
              setShowModal={setShowModal}
            />
          )}
          {subscription.interval === 'year' && (
            <CurrentPlanCard
              title="Annual"
              interval="year"
              description="$89 cost savings compared to the monthly plan"
              price={subscription.price}
              renews={subscription.renews}
              setShowModal={setShowModal}
            />
          )}
          {subscription.plan?.interval === TRIAL && (
            <CurrentPlanCard
              title="Free Trial"
              description=""
              price={subscription.price}
              showUpgrade
              setShowModal={setShowModal}
            />
          )}
          {subscription.plan?.interval === FOREVER && (
            <CurrentPlanCard
              title="Forever"
              interval="∞"
              description=""
              price={subscription.price}
              setShowModal={setShowModal}
            />
          )}
          {canRestartSubscription && (
            <div className="restart-sub-wrap">
              <div className="header-wrap">
                <div className="icon-wrap">
                  <InformationCircleIcon />
                </div>
                <div className="text-wrap">
                  <h2 className="title">Reactivate your subscription.</h2>
                  <p>Your plan is ending on {moment.unix(subscription.end!).format('M/D/YY')}</p>
                </div>
              </div>
              <div className="button-wrap">
                <Button isLoading={processing} type="large" onClick={() => reactivateUserSub()}>
                  Reactivate Subscription
                </Button>
              </div>
            </div>
          )}
        </>
      )}
    </StyledCurrentPlan>
  )
}

export default CurrentPlan
